import axios from "../../services/axios.config";
import {
  fetchAllFilteredTimesheets,
  fetchFilteredTimesheets,
} from "@/services/timesheetListApi";

const endpoints = {
  getTimeSheetOfAllUser: `api/users/timesheets/get-timesheet/`,
  addTimeSheet: `api/users/timesheets/create-new-timesheet/`,
  editTimeSheet: `api/users/timesheets/edit-timesheet/`,
  deleteTimeSheet: `api/users/timesheets/delete-timesheet/`,
  bulkedit: `api/users/timesheets/edit-timesheet-bulk/`,
};

const state = {
  timeLogOfAllUser: [],
};

const getters = {
  getTimeLogsOfAllUser: (state) => state.timeLogOfAllUser,
};

const actions = {
  fetchTimeSheetOfAllUser: async ({commit}) => {
    const rows = await fetchAllFilteredTimesheets("");
    commit("setUserTimeSheetData", rows);
  },
  filterTimeSheet: async ({commit}, filterQuery) => {
    const rows = await fetchAllFilteredTimesheets(filterQuery);
    commit("setUserTimeSheetData", rows);
  },
  filterTimeSheetAdvanced: async ({commit}, filters) => {
    const rows = await fetchFilteredTimesheets(filters || {});
    commit("setUserTimeSheetData", rows);
    return rows;
  },
  addNewTimeSheet: async ({commit}, timeLog) => {
    const data = {
      user_id: timeLog.user,
      project_id: timeLog.project,
      task_description: timeLog.description,
      log_description: timeLog.description,
      timer_log_date: timeLog.date,
      log_date: timeLog.date,
      hours_with_timer: timeLog.hours,
      hours: timeLog.hours,
      working_hours: timeLog.hours,
    };
    let response = await axios.post(endpoints.addTimeSheet, data);
    if (response.status === 201) {
      commit("addTimeSheetData", response.data);
    }
  },
  addBulkTimeSheet: async ({commit}, timeLog) => {
    let response = await axios.put(endpoints.bulkedit, timeLog);
    if (response.status === 201) {
      commit("addTimeSheetData", response.data);
    }
  },
  updateTimeSheet: async ({commit}, timesheet) => {
    let response = await axios.put(
      endpoints.editTimeSheet + timesheet.id,
      timesheet
    );
    if (response.status === 200) {
      commit("updateTimeSheetData", timesheet);
    }
  },
  deleteTimeSheet: async ({commit}, timesheetId) => {
    let response = await axios.delete(endpoints.deleteTimeSheet + timesheetId);
    if (response.status === 204) {
      commit("deleteTimeSheetData", timesheetId);
    }
  },
};

const mutations = {
  setUserTimeSheetData: (state, value) => {
    state.timeLogOfAllUser = Array.isArray(value) ? value : [];
  },
  addTimeSheetData: (state, value) => {
    state.timeLogOfAllUser.push(value);
  },
  updateTimeSheetData: (state, value) => {
    const i = state.timeLogOfAllUser.findIndex((item) => {
      if (item.id !== value.id) return;
      return value.id;
    });
    if (i === -1) return;
    state.timeLogOfAllUser.splice(i, 1, value);
  },

  deleteTimeSheetData: (state, id) => {
    const i = state.timeLogOfAllUser.map((item) => item.id).indexOf(id);
    if (i === -1) return;
    state.timeLogOfAllUser.splice(i, 1);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
